import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { IReadingData } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';

@Component({
  selector: 'app-add-reading-target-age',
  templateUrl: './add-reading-target-age.component.html',
  styleUrls: ['./add-reading-target-age.component.scss']
})
export class AddReadingTargetAgeComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Add new target age"

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<AddReadingTargetAgeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }


  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      description: [null],
    })
    const { ITEM } = this.data;
    if (ITEM) {
      this.TITLE = "Edit target age";
      const { name, description } = ITEM;
      this.form.patchValue({
        name, description
      })
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { ITEM } = this.data;
      const { user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { name, description } = f;
      const registerStatus = STATUS_OBJECT.submitted;

      const item: IReadingData = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name}`.trim()),
        organizationRef: null,
        organizationKey: null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: `${name}`.trim() || null,
        description: description || null,
      }

      this.store.addNewItem(COLLECTION_NAME.READING_TARGET_AGE, item, (success, res) => {
        if (success) {
          this.store.fetchData(COLLECTION_NAME.READING_TARGET_AGE, registerStatus.key)
          this.snackBar.open("Data has been created successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close('yes');
        }
      })
    }
  }
}
